import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {BlacklistsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {BlacklistsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new BlacklistsListItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'projectName'),
		getString(result, 'messageType'),
		getString(result, 'clientId'),
	);

	return result;
}

// @note There is no output function since list is read only.